<template>
  <div>
    <el-dialog
      :title="$t('common_46019')"
      width="800px"
      :lock-scroll="false"
      :visible="visible"
      @close="close"
    >
      <div class="active-list">
        <div :class="['a-items',val == v.id ? 'active':'']" v-for="(v,k) in list" :key="k" @click="checkBanner(v.url)">
          <p>{{v.name}}</p>
          <img :src="v.url"/>
        </div>

      </div>
        
    </el-dialog>
  </div>
</template>

<script>
import {
  requestUrl,
  ajax,
} from "@/assets/utils/network";
export default {
  // props: {
  //   visible: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  data() {
    return {
      imgList:[],
      url: `${requestUrl}/file`,
      val:'',
      visible:true,
      list:[
        {
          id:1,
          name:this.$parent.$t('common_46020'),
          url: 'http://test-file-repository.oss-cn-beijing.aliyuncs.com/2026/3/20/11/ee2c3de6301c4970b69fe2cebb985a36.png',
        },
        {
          id:2,
          name:this.$parent.$t('common_46021'),
          url: 'http://test-file-repository.oss-cn-beijing.aliyuncs.com/2026/3/20/11/98c7be7efcd64e7da67154a83c9f8975.png',
        },
        {
          id:3,
          name:this.$parent.$t('common_46022'),
          url: 'http://test-file-repository.oss-cn-beijing.aliyuncs.com/2026/3/20/11/09f3e0fbaccd4a8ea133d1ef4dfc8342.png',
        },
        {
          id:4,
          name:this.$parent.$t('common_46023'),
          url: 'http://test-file-repository.oss-cn-beijing.aliyuncs.com/2026/3/20/11/bd7bc21aacd942f898f3e3341359c749.png',
        },
        {
          id:5,
          name:this.$parent.$t('common_61158'),
          url: 'http://test-file-repository.oss-cn-beijing.aliyuncs.com/2026/3/20/11/b24559a8a3814a75b0f4bcac74f3b908.png',
        },
        {
          id:6,
          name:this.$parent.$t('common_80002'),
          url: 'http://test-file-repository.oss-cn-beijing.aliyuncs.com/2026/3/20/11/47dd123c95e447429dd8d79e00449d38.png',
        },
        {
          id:7,
          name:this.$parent.$t('common_74018'),
          url: 'http://test-file-repository.oss-cn-beijing.aliyuncs.com/2026/3/20/11/500f802d85234062b751601e2dfa8b31.png',
        },

      ]
    };
  },
  mounted() {
  },
  methods: {
    checkBanner (v) {
      this.val = v
      this.$emit("confirm", {val: v});
      this.close()
      
    },
    close() {
      this.$emit("close");
      this.val = ''
    },
  },
};
</script>

<style lang="scss">
.active-list{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .a-items{
    width: 340px;
    height: 196px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid #E6E7EC;
    margin-bottom: 30px;
    box-sizing: border-box;
    color: #1B2330;
    cursor: pointer;
    &:hover{
      border: 1px solid #5278E2;
      p{
      color: #5278E2;
      }
    }
    &.active{
      border: 1px solid #5278E2;
      p{
      color: #5278E2;
      }

    }
    img{
      display: block;
      width: 280px;
      height: 106px;
    }
    p{
      margin-bottom: 10px;
      color: #1B2330;
    }
  }
}
</style>
